import { render, staticRenderFns } from "./THelp.vue?vue&type=template&id=3f465bbf&scoped=true&"
import script from "./THelp.vue?vue&type=script&lang=js&"
export * from "./THelp.vue?vue&type=script&lang=js&"
import style0 from "./THelp.vue?vue&type=style&index=0&id=3f465bbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.10.0_babel-core@7.0.0-bridge.0_@babel+core@7.19.3__cache-loader@4.1.0_web_c7e2a9737e7b7d65140c95ac56c8a121/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f465bbf",
  null
  
)

export default component.exports